class BarracudaCart{
    constructor(opener, target, cartPage) {
        console.log(cartPage);
        this.debug = false;
        if(opener && target){
            this.opener = opener;
            this.target = target;
            this.counterContainer = this.opener.querySelector(".count-container");
            this.counter = this.opener.querySelector(".count")
            this.timer = null
            this.cartPage = cartPage;

            this.init();
            if (this.cartPage)
                console.log("Cart initialization")
                this.initButtonsInLines();
        }else{
            console.error("Barracuda Cart need opener and target element")
        }
    }
    init(){
        /* when click on cart opener, refresh content */
        this.opener.addEventListener("click",this.refreshCart.bind(this));

        /* find all addToCart buttons on page and change them to ajax */
        document.querySelectorAll(".barracuda-cart-addToCartButton").forEach(button=>{
            this.appendAddToCartButton(button);
        })

        /* same size gate for Buy It Now (dynamic checkout) buttons */
        this.bindBuyNowGuards();
        this.guardGokwikBuyNowFn();
        this.guardKwikCartAddFn();
        this.bindViewCartRefresh();
        this.refreshViewCartButtons();
        if(typeof Barracuda !== 'undefined' && Barracuda.reInit && !Barracuda.reInit.buyNowGuardWrapped){
            const originalReInit = Barracuda.reInit;
            const self = this;
            Barracuda.reInit = function(){
                const result = originalReInit.apply(this, arguments);
                self.bindBuyNowGuards();
                self.refreshViewCartButtons();
                return result;
            };
            Barracuda.reInit.buyNowGuardWrapped = true;
        }

    }
    bindBuyNowGuards(){
        document.querySelectorAll("form .shopify-payment-button").forEach(container=>{
            if(container.dataset.sizeGuardBound) return;
            container.dataset.sizeGuardBound = "true";
            container.addEventListener("click", (e)=>{
                const form = container.closest("form");
                const sizePicker = form ? form.querySelector('barracuda-variant-picker[option-name="size" i]') : null;
                if(sizePicker && !sizePicker.querySelector('.options-frame .swatch.selected')){
                    e.preventDefault();
                    e.stopPropagation();
                    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
                    this.showSizeError(sizePicker);
                    return false;
                }
            }, true);
        });
    }
    guardGokwikBuyNowFn(){
        /* Fallback for cached/old gokwik.liquid on demo: wrap the GoKwik
           onBuyNowClick SDK fn so Buy Now still requires a size. Listener
           order can't be relied on (GoKwik registers on window in <head>),
           but wrapping the SDK entry point always runs before checkout. */
        if(this._gokwikGuarded) return;
        this._gokwikGuarded = true;
        var self = this;
        function wrapFn(original){
            if(!original || original.__mercazeSizeWrapped) return original;
            var wrapped = function(e){
                try{
                    var btn = e && e.target && e.target.closest ? (e.target.closest('.gokwik-marge') || e.target) : null;
                    var form = btn && btn.closest ? btn.closest('form') : null;
                    if(!form || !form.querySelector('[name="id"]')){
                        var forms = document.querySelectorAll("form[action*='/cart/add']");
                        for(var i=0;i<forms.length;i++){
                            if(forms[i].offsetParent !== null && forms[i].querySelector('[name="id"]')){ form = forms[i]; break; }
                        }
                        if(!form) form = document.querySelector("form[action*='/cart/add']");
                    }
                    var picker = form ? form.querySelector('barracuda-variant-picker[option-name="size" i]') : null;
                    if(picker && !picker.querySelector('.options-frame .swatch.selected')){
                        if(e){ e.preventDefault(); if(e.stopPropagation) e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
                        self.showSizeError(picker);
                        return false;
                    }
                }catch(err){ console.warn('[Mercaze] size guard check failed', err); }
                return original.apply(this, arguments);
            };
            wrapped.__mercazeSizeWrapped = true;
            return wrapped;
        }
        try{
            var current = window.onBuyNowClick;
            if(typeof current === 'function'){ window.onBuyNowClick = wrapFn(current); }
            var holder = { val: window.onBuyNowClick };
            Object.defineProperty(window, 'onBuyNowClick', {
                configurable: true,
                get(){ return holder.val; },
                set(next){ holder.val = (typeof next === 'function') ? wrapFn(next) : next; }
            });
        }catch(err){ console.warn('[Mercaze] could not guard onBuyNowClick', err); }
    }
    guardKwikCartAddFn(){
        /* GoKwik Slide Cart drawer hijacks product-page ATC buttons in capture
           phase (form[action='/cart/add'] button[type='submit'] matched) and
           calls window.addItemtoCartFromForm(event) with stopImmediatePropagation,
           so our bubble-phase addToCart guard never runs. The drawer's code is
           external and can't be edited — instead wrap its entry point. Wrapping
           the global is order-independent: Kwik's own listener calls through it.
           Strictly scoped to clicks inside a product form so drawer upsell adds
           (different products, no size UI) are never blocked. */
        if(this._kwikGuarded) return;
        this._kwikGuarded = true;
        var self = this;
        function wrapFn(original){
            if(!original || original.__mercazeSizeWrapped) return original;
            var wrapped = function(e){
                try{
                    var form = (e && e.target && e.target.closest) ? e.target.closest("form[action*='/cart/add']") : null;
                    var picker = null;
                    try{ picker = form ? form.querySelector('barracuda-variant-picker[option-name="size" i]') : null; }catch(err2){ picker = null; }
                    if(picker && !picker.querySelector('.options-frame .swatch.selected')){
                        if(e){ e.preventDefault(); if(e.stopPropagation) e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
                        self.showSizeError(picker);
                        try{ picker.querySelector('.options-frame').scrollIntoView({behavior:'smooth', block:'center'}); }catch(err3){}
                        return false;
                    }
                }catch(err){ console.warn('[Mercaze] kwik size guard check failed', err); }
                return original.apply(this, arguments);
            };
            wrapped.__mercazeSizeWrapped = true;
            return wrapped;
        }
        try{
            var holder = { val: window.addItemtoCartFromForm };
            if(typeof holder.val === 'function'){ holder.val = wrapFn(holder.val); }
            Object.defineProperty(window, 'addItemtoCartFromForm', {
                configurable: true,
                get(){ return holder.val; },
                set(next){ holder.val = (typeof next === 'function') ? wrapFn(next) : next; }
            });
        }catch(err){ console.warn('[Mercaze] could not guard addItemtoCartFromForm', err); }
    }
    appendAddToCartButton(element){
        if(!element || element.dataset.atcBound) return;
        element.dataset.atcBound = "true";
        element.addEventListener("click",this.addToCart.bind(this));
    }
    cartUrl(){
        return (document.body.dataset && document.body.dataset.carturl) || '/cart';
    }
    viewCartText(button){
        return (button.dataset && button.dataset.viewCart) || 'View Cart';
    }
    /* Blissclub-style: once the current variant is in cart, swap ATC → View Cart link */
    setViewCartMode(form, inCart){
        var current = form.querySelector('.barracuda-cart-addToCartButton, [data-view-cart-link]');
        if(!current) return;
        if(inCart){
            if(current.hasAttribute('data-view-cart-link')) return;
            if(current.classList.contains('disabled')) return;
            var link = document.createElement('a');
            link.className = current.className + ' view-cart-mode';
            link.setAttribute('href', this.cartUrl());
            link.setAttribute('data-view-cart-link', 'true');
            link.textContent = this.viewCartText(current);
            form._originalAtcButton = current;
            current.parentNode.replaceChild(link, current);
        }else{
            if(!current.hasAttribute('data-view-cart-link')) return;
            var original = form._originalAtcButton;
            if(original){
                current.parentNode.replaceChild(original, current);
                this.appendAddToCartButton(original);
                form._originalAtcButton = null;
            }
        }
    }
    refreshViewCartButtons(){
        var self = this;
        axios.get('/cart.js').then(function(response){
            var ids = {};
            (response.data.items || []).forEach(function(it){ ids[it.variant_id] = true; });
            document.querySelectorAll('form').forEach(function(form){
                var sel = form.querySelector('select[name=id]');
                var btnArea = form.querySelector('.barracuda-cart-addToCartButton, [data-view-cart-link]');
                if(!sel || !btnArea) return;
                self.setViewCartMode(form, !!ids[parseInt(sel.value)]);
            });
        }).catch(function(error){ console.error(error); });
    }
    bindViewCartRefresh(){
        /* variant change → re-evaluate (new variant usually not in cart → back to Add) */
        var self = this;
        if(this._viewCartChangeBound) return;
        this._viewCartChangeBound = true;
        document.addEventListener('change', function(e){
            if(e.target && e.target.matches && e.target.matches('select[name=id]')){
                self.refreshViewCartButtons();
            }
        });
        /* swatch/block pickers update the hidden select programmatically
           (no native change event) — they dispatch bubbling option:change */
        var refreshTimer = null;
        document.addEventListener('option:change', function(){
            if(refreshTimer) clearTimeout(refreshTimer);
            refreshTimer = setTimeout(function(){ self.refreshViewCartButtons(); }, 150);
        });
    }
    initButtonsInLines(){
        // all buttons in cart topbar
        this.target.querySelectorAll(".barracuda-cart-removeButton").forEach(button=>{
            button.addEventListener("click",this.removeFromCart.bind(this));
        })
        this.target.querySelectorAll(".barracuda-cart-quantityInput").forEach(input=>{
            new BarracudaCount(input);
            input.addEventListener("change",this.setQuantityCart.bind(this));
        })

        // and all buttons in cart page (if exists)
        if(this.cartPage){
            this.cartPage.querySelectorAll(".barracuda-cart-removeButton").forEach(button=>{
                button.addEventListener("click",this.removeFromCart.bind(this));
            })
            this.cartPage.querySelectorAll(".barracuda-cart-quantityInput").forEach(input=>{
                new BarracudaCount(input);
                input.addEventListener("change",this.setQuantityCart.bind(this));
            })
        }

        Barracuda.init(); // init collapsible
    }
    getCart(){
        this.target.classList.add("loading");
        axios.get('/cart.js')
        .then(function (response) {
            this.target.classList.remove("loading");
            if(response.data['item_count']) this.refreshCartIcon(response.data['item_count']) 
                else this.refreshCartIcon(0);
        }.bind(this))
        .catch(function (error) {
            this.target.classList.remove("loading");
            console.error(error);
        });
    }
    refreshCartIcon(count = null){
        if(count != null){
            if(count > 0){
                this.counter.innerText = ""+count;
                this.counterContainer.classList.remove("hide");
                if(count > 9){
                    this.counterContainer.classList.add("more-than-9");
                    this.counterContainer.classList.remove("more-than-99");
                }else if(count > 99){
                    this.counterContainer.classList.remove("more-than-9");
                    this.counterContainer.classList.add("more-than-99");
                }else{
                    this.counterContainer.classList.remove("more-than-9");
                    this.counterContainer.classList.remove("more-than-99");
                }
            }else{
                this.counter.innerText = "0";
                this.counterContainer.classList.add("hide");
            }
            var opener = this.opener;

        }else{
            this.getCart();
        }
    }
    refreshCart(){
        axios.get(document.body.dataset.carturl)
        .then(function (response) {
            var x = document.createElement("html");
            x.innerHTML = response.data;
            let data = x.querySelector("#page-content>.section-main-cart .main-cart-content").cloneNode(true);
            this.target.innerHTML = "";
            if(data) this.target.appendChild(data);
            this.target.classList.remove("hide");
            if (this.cartPage){
                this.cartPage.innerHTML = "";
                this.cartPage.appendChild(data.cloneNode(true));
            };
            this.refreshViewCartButtons();
            this.initButtonsInLines();
        }.bind(this))
        .catch(function (error) {
            console.error(error);
        });
    }
    addToCart(e, item = null, count = 1, plans = null){
        if(this.timer){
            clearTimeout(this.timer);
        }
        var form = e.target ? e.target.closest("form") : null;
        if(!form) return;

        var sizePicker = form.querySelector('barracuda-variant-picker[option-name="size" i]');
        if(sizePicker && !sizePicker.querySelector('.options-frame .swatch.selected')){
            prevent(e);
            this.showSizeError(sizePicker);
            return;
        }

        form.classList.add("adding-to-cart");

        if(item==null) item = parseInt(form.querySelector("select[name=id]").value)
        if(form.querySelector("input[name=quantity]")) count = parseInt(form.querySelector("input[name=quantity]").value)
        if (form.querySelector("*[name=selling_plan]")) plans = parseInt(form.querySelector("*[name=selling_plan]").value)

        var maxCount = null
        console.log(form.querySelector("select[name=id] option[selected]"))
        if(form.querySelector("select[name=id]") && form.querySelector("select[name=id] option[selected]").dataset.max) {
            maxCount = parseInt(form.querySelector("select[name=id] option[selected]").dataset.max)
        }

        prevent(e);
        if ((maxCount == null || maxCount < 0 || count <= maxCount)) {
            if (!form.querySelector('input[type=file]')){
                prevent(e);
                if (this.debug) console.log("Barracuda Cart - addToCart", item, count, plans, "event: ", e);
            
                var data = {
                    items: [{
                        quantity: count,
                        id: item
                    }]
                }
            
                if (plans != null && plans != "") {
                    data.items[0].selling_plan = plans
                }
                        
                let formData = new FormData(form)
                for (const [key, value] of formData) {
                    if (key.includes("properties[")) {
                        if (!data.items[0].properties) data.items[0].properties = {}
                        data.items[0].properties[key.substring(11, key.length - 1)] = value
                    }
                }
                    
                axios.post('/cart/add.js', data)
                    .then(function (response) {
                        if (this.debug) console.log("Barracuda Cart - added to cart", response);
                        setTimeout(() => {
                            this.refreshCartIcon()
                            this.animateCartIcon()
                            this.refreshViewCartButtons()
                            if (this.cartPage) this.refreshCart();
                            form.classList.remove("adding-to-cart");
                            form.classList.add("added-to-cart");

                            var targetProduct = form.closest(".product-form");
                            if (targetProduct && targetProduct.querySelector(".cant-add-more")) {
                                targetProduct.querySelector(".cant-add-more").classList.add("visually-hidden");
                            }
                            if (targetProduct && targetProduct.querySelector(".cant-add-other")) {
                                targetProduct.querySelector(".cant-add-other").classList.add("visually-hidden");
                            }

                            document.body.classList.remove("show-overlay");
                            unlockBodyPosition();
                        }, 300);
                        
                    }.bind(this))
                    .catch(function (error) {
                        form.classList.remove("adding-to-cart");
                        form.classList.add("error-when-adding-to-cart");
                        console.error(error);
                        var targetProduct = form.closest(".product-form");
                        if (error.response.status = "422" && targetProduct && targetProduct.querySelector(".cant-add-other span.message")) {
                            targetProduct.querySelector(".cant-add-other span.message").innerHTML = error.response.data.description;
                            targetProduct.querySelector(".cant-add-more").style.height = targetProduct.querySelector(".cant-add-more").scrollHeight+"px";
                            targetProduct.querySelector(".cant-add-other").classList.remove("visually-hidden");
                            
                            setTimeout(function () {
                                targetProduct.querySelector(".cant-add-other").classList.add("visually-hidden");
                                targetProduct.querySelector(".cant-add-other").style.removeProperty("height");
                            }, 5000);
                        }
                    });
            }else form.submit();
        }else{
            prevent(e);
            var targetProduct = form.closest(".product-form");
            if(targetProduct && targetProduct.querySelector(".cant-add-more")){
                targetProduct.querySelector(".cant-add-more").style.height = targetProduct.querySelector(".cant-add-more").scrollHeight+"px";
                targetProduct.querySelector(".cant-add-more").classList.remove("visually-hidden");
                this.timer = setTimeout(function(){
                    targetProduct.querySelector(".cant-add-more").classList.add("visually-hidden");
                    targetProduct.querySelector(".cant-add-other").style.removeProperty("height");
                    if(form.querySelector("input[name=quantity]")) form.querySelector("input[name=quantity]").value = maxCount;
                },5000);
            }
            form.classList.remove("adding-to-cart");
            form.classList.add("error-when-adding-to-cart");
        }
        
    }
    showSizeError(sizePicker){
        var frame = sizePicker.querySelector('.options-frame');
        if(!frame) return;

        var msg = sizePicker.querySelector('.size-select-error');
        if(!msg){
            msg = document.createElement('span');
            msg.className = 'size-select-error';
            msg.textContent = 'Please select a size';
            frame.insertAdjacentElement('afterend', msg);
        }
        msg.classList.add('visible');

        frame.classList.remove('shake');
        void frame.offsetWidth;
        frame.classList.add('shake');

        if(this.sizeErrorTimer) clearTimeout(this.sizeErrorTimer);
        this.sizeErrorTimer = setTimeout(function(){
            msg.classList.remove('visible');
            frame.classList.remove('shake');
        }, 3000);
    }
    removeFromCart(e){
        prevent(e)
        this.setQuantityCart(e, null, 0);
    }
    setQuantityCart(e, id= null, quantity = null){
        if(this.timer){
            clearTimeout(this.timer);
        }

        if(id == null) id = e.target.closest(".item-line").dataset.id;
        if(quantity == null) quantity = e.target.closest("input").value;
        var maxCount = null 
        if(e.target.closest("input") && e.target.closest("input").dataset.max){
            maxCount = parseInt(e.target.closest("input").dataset.max);
        }

        if(maxCount == null || maxCount < 0 || quantity <= maxCount){
            /* create fade for item-line in cart, when user remove last item from line. */ 
            if(quantity == 0){
                var line = e.target.closest(".item-line")
                line.style.height = line.scrollHeight + "px";
                line.classList.add("item-line-removed");
                setTimeout(()=>{
                    line.style.height = "0px";
                },10);
            }

            prevent(e)
            setTimeout(()=>{
                var data = {'updates' : {}};
                data['updates'][id] = quantity;

                    axios.post('/cart/update.js',data)
                    .then(function (response) {
                        
                        this.refreshCart();
                        this.refreshCartIcon();
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    });
            },400);
        }else{
            console.warn("You can't add more then "+maxCount+" item/items to the cart.");
            var cantAdd =  e.target.closest(".item-line").querySelector(".cant-add-more")
            if(cantAdd){
                cantAdd.classList.remove("visually-hidden");
            }

            this.timer = setTimeout(function(){
                setTimeout(()=>{
                    e.target.closest("input").value = maxCount;
                    var data = {'updates' : {}};
                    data['updates'][id] = maxCount;

                        axios.post('/cart/update.js',data)
                        .then(function (response) {
                            this.refreshCart();
                            this.refreshCartIcon();
                        }.bind(this))
                        .catch(function (error) {
                            console.error(error);
                        });
                },400);
            }.bind(this),5000);
        }
    }
    animateCartIcon(){
        document.body.classList.remove("scroll-down")
        document.body.classList.add("scroll-top")
        this.counterContainer.classList.remove("animate");
        setTimeout(()=>{
        this.counterContainer.classList.add("animate");
        },5)
    }
}